/**
 * Returns true if an item with optional feature-flag guards should be visible.
 *
 * - `ffForHiding`:    when set and the flag is ON  → hidden
 * - `ffForDisplaying`: when set and the flag is OFF → hidden
 * - If neither is set the item is always visible.
 */
export const isVisibleByFeatureFlags = (
  item: { ffForDisplaying?: string; ffForHiding?: string },
  featureFlags: Record<string, boolean>
): boolean => (!item.ffForHiding || !featureFlags[item.ffForHiding]) && (!item.ffForDisplaying || !!featureFlags[item.ffForDisplaying]);
